import Card from '@mui/material/Card'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

import type { ActiviteitTemplate as ActiviteitTemplateType } from '../types/ActiviteitTemplate'

import { ActiviteitTemplate } from './ActiviteitTemplate'

const headerCells = [
  { id: 'type', label: 'Type' },
  { id: 'planning', label: 'Planning' },
  { id: 'assignedto', label: 'Toegewezen aan' },
  { id: 'other', label: 'Overige informatie' },
]

type Props = {
  projectType: 'Aanvraag' | 'Hoofdleiding'
  templates: ActiviteitTemplateType[]
}

export const ActiviteitTemplates = ({ projectType, templates }: Props) => {
  return (
    <>
      {templates.length > 0 ? (
        <Card>
          <Table>
            <TableHead>
              <TableRow>
                {headerCells.map((headerCell) => (
                  <TableCell key={headerCell.id}>{headerCell.label}</TableCell>
                ))}

                {projectType === 'Aanvraag' && (
                  <>
                    <TableCell>Ingangsdatum KCM1</TableCell>
                    <TableCell>Uitgesloten bij bepaling KCM1</TableCell>
                  </>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {templates.map((template) => {
                return (
                  <ActiviteitTemplate
                    activiteitTemplate={template}
                    key={template._id}
                  />
                )
              })}
            </TableBody>
          </Table>
        </Card>
      ) : null}
    </>
  )
}
